// extracted by mini-css-extract-plugin
export default {"columnSpace":"ZwgLevel_columnSpace__oLfi8"};